import React from 'react';

// import { Container } from './styles';

export default function Configuration() {
  return (
    <div>Configurations of users</div>
  );
}
